var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 5.76649C5.85489 5.76649 4.99645 6.12927 4.36351 6.77504C3.73058 7.4208 3.375 8.29664 3.375 9.20989V9.55595L13.5 15.1188L23.625 9.55768V9.20989C23.625 8.29664 23.2694 7.4208 22.6365 6.77504C22.0035 6.12927 21.1451 5.76649 20.25 5.76649H6.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.625 11.5118L13.8999 16.8542C13.777 16.9218 13.6396 16.9571 13.5 16.9571C13.3604 16.9571 13.223 16.9218 13.1001 16.8542L3.375 11.5118V19.5401C3.375 20.4534 3.73058 21.3292 4.36351 21.975C4.99645 22.6207 5.85489 22.9835 6.75 22.9835H20.25C21.1451 22.9835 22.0035 22.6207 22.6365 21.975C23.2694 21.3292 23.625 20.4534 23.625 19.5401V11.5118Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.48b4cc1d4cc1858f73d0b99f44c23d34.svg";
export { ForwardRef as ReactComponent };